import { IConstructorBrowseResponse } from 'shared/types/ConstructorBrowseResponse';
import { IFeed, ISubSection } from 'homepage/types/Feed';

export enum HomepageTabActions {
  setActiveTab = 'setActiveTab',
  setCurrentSearchLandingFeedData = 'setCurrentSearchLandingFeedData',
  setDefaultSearchLandingFeedData = 'setDefaultSearchLandingFeedData',
  setHomepageBackgroundPosition = 'setHomepageBackgroundPosition',
  setIsDiscoverTabOpen = 'setIsDiscoverTabOpen',
  setIsLoading = 'setIsLoading',
  setOpenTabScrollPosition = 'setDiscoverTabScrollPosition',
  setSelectedTab = 'setSelectedTab',
  setVisitedByBackButton = 'setVisitedByBackButton',
}

export interface IHomepageTabAction {
  type: HomepageTabActions;
  payload: boolean;
}

export interface IHomepageTabActiveTabAction {
  type: HomepageTabActions;
  payload: string;
}
export interface IHomepageTabOpenTapScrollPositionAction {
  type: HomepageTabActions;
  payload: number;
}

type IHomepageTabStateAction =
  | { type: HomepageTabActions.setActiveTab; payload: string | null }
  | {
      type: HomepageTabActions.setCurrentSearchLandingFeedData;
      payload: {
        index: number;
        constructorResponse?: IConstructorBrowseResponse | null;
        subsections?: ISubSection[] | null;
      };
    }
  | { type: HomepageTabActions.setDefaultSearchLandingFeedData; payload: IFeed | null }
  | { type: HomepageTabActions.setHomepageBackgroundPosition; payload: number }
  | { type: HomepageTabActions.setIsDiscoverTabOpen; payload: boolean }
  | { type: HomepageTabActions.setIsLoading; payload: boolean }
  | { type: HomepageTabActions.setOpenTabScrollPosition; payload: number }
  | { type: HomepageTabActions.setSelectedTab; payload: string }
  | { type: HomepageTabActions.setVisitedByBackButton; payload: boolean };

export type IHomepageTabDispatch = (action: IHomepageTabStateAction) => void;

export interface IHomepageTabState {
  activeTab: string | null;
  currentSearchLandingFeedData: IFeed | null;
  homepageScrollPosition: number;
  isDiscoverTabOpen: boolean;
  isLoading: boolean;
  openTabScrollPosition: number;
  visitedByBackButton: boolean;
}

export const homepageTabReducer = (state: IHomepageTabState, action: IHomepageTabStateAction) => {
  switch (action.type) {
    case HomepageTabActions.setActiveTab:
      state.activeTab = action.payload;
      if (action.payload === 'Discover') {
        state.isDiscoverTabOpen = true;
      } else {
        state.isDiscoverTabOpen = false;
      }
      break;
    case HomepageTabActions.setCurrentSearchLandingFeedData:
      if (
        action?.payload?.constructorResponse &&
        state.currentSearchLandingFeedData &&
        typeof action?.payload?.index === 'number'
      ) {
        const currentState = { ...state.currentSearchLandingFeedData };
        const sections = [...currentState?.sections];
        sections[action?.payload?.index].constructorResponse = action?.payload?.constructorResponse;
        delete currentState?.sections;
        const updatedState = { ...currentState, sections };
        state.currentSearchLandingFeedData = updatedState;
      } else if (
        action?.payload?.subsections &&
        state.currentSearchLandingFeedData &&
        typeof action?.payload?.index === 'number'
      ) {
        const currentState = { ...state.currentSearchLandingFeedData };
        const sections = [...currentState?.sections];
        sections[action?.payload?.index].subsections = action?.payload?.subsections;
        delete currentState?.sections;
        const updatedState = { ...currentState, sections };
        state.currentSearchLandingFeedData = updatedState;
      }
      break;
    case HomepageTabActions.setDefaultSearchLandingFeedData:
      if (action?.payload?.id) {
        state.currentSearchLandingFeedData = action.payload;
      }
      break;
    case HomepageTabActions.setHomepageBackgroundPosition:
      state.openTabScrollPosition = action.payload;
      break;
    case HomepageTabActions.setIsDiscoverTabOpen:
      state.isDiscoverTabOpen = action.payload;
      break;
    case HomepageTabActions.setIsLoading:
      state.isLoading = action.payload;
      break;
    case HomepageTabActions.setOpenTabScrollPosition:
      state.openTabScrollPosition = action.payload;
      break;
    case HomepageTabActions.setVisitedByBackButton:
      state.visitedByBackButton = action.payload;
      break;
    default:
      return state;
  }
  return state;
};
